const uz = {
    meta: {
        title: "Computer vision biznesda qo'llash — narx va aniqlik",
        description:
            "Computer vision biznesda qo'llash: ombor, do'kon va ishlab chiqarishda uchta stsenariy, aniqlik 90-97 foiz, narx 45 mln so'mdan va qaytim hisobi.",
        keywords: [
            "computer vision biznesda qo'llash",
            "kamera orqali nazorat tizimi",
            "ombor nazorati sun'iy intellekt",
            "xavfsizlik qoidalari nazorati kamera",
            "raqamli tasvir tahlili narxi",
            "videoanalitika ombor",
            "computer vision narxi",
        ],
    },
    h1: "Computer vision amalda: ombor, do'kon va ishlab chiqarishda kamera nimani nazorat qiladi",
    lead:
        "Kameralar allaqachon o'rnatilgan, lekin yozuvni hech kim ko'rmaydi — muammo chiqqandan keyingina orqaga qaytib qaraladi. Computer vision shu yozuvni real vaqtda tahlil qiladi va hodisani o'zi xabar qiladi. Bu maqolada uchta amaliy stsenariy, halol aniqlik ko'rsatkichlari, narx va qaytim hisobi bor.",
    category: "Sun'iy intellekt",
    readingTime: "11 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Ko'pchilik obyektda video kuzatuv bor, lekin u faqat arxiv vazifasini bajaradi. Yo'qotish aniqlangandan keyin operator soatlab yozuvni ko'radi va ko'pincha hech narsa topmaydi. Computer vision shu ishni teskari qiladi: tizim hodisani o'sha zahoti belgilaydi va kadr-dalil bilan xabar yuboradi.",
        },
        {
            type: "p",
            text:
                "Mavzu bugun kun tartibiga chiqqanining ikkita sababi bor. Birinchisi — davlat tomoni: 2025–2026 yillar uchun AI joriy etish bo'yicha 60 dan ortiq loyihadan iborat ro'yxat tasdiqlangan, 10 000 korxona uchun AI-hamkor dasturida esa joriy etish xarajatlarining 50 foizi qoplab berilishi e'lon qilingan. Ikkinchisi — nazoratning qat'iylashuvi: markirovka qoidalarini buzish 2026-yil 1-sentyabrdan yuqori soliq riski omili hisoblanadi, ya'ni jismoniy tovar oqimini hujjat bilan moslashtirish endi ixtiyoriy emas.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Computer vision nima qiladi va nimani qila olmaydi" },
        {
            type: "p",
            text:
                "Computer vision — kamera tasvirini avtomatik tahlil qiladigan model. U kadrda obyektni topadi, uni sanaydi, harakatini kuzatadi va oldindan kelishilgan qoidaga mos kelmasa hodisa yaratadi. Masalan: yuk mashinasi kelganda tushirilgan palletlar sonini sanash yoki kaska kiymagan xodimni belgilash.",
        },
        {
            type: "p",
            text:
                "Nimani qila olmasligini ham aytish kerak. Model niyatni tushunmaydi va kontekstni bilmaydi — u faqat o'zi o'rgatilgan obyektlarni ko'radi. Yangi qadoq turi paydo bo'lsa yoki kamera burchagi siljisa, sifat tushadi. Shuning uchun har loyihada qayta o'qitish sikli oldindan rejalashtiriladi.",
        },

        { type: "h2", text: "Uchta amaliy stsenariy" },
        { type: "h3", text: "1. Ombordagi yuklash va tushirishni tekshirish" },
        {
            type: "p",
            text:
                "Kamera darvoza zonasini kuzatadi va har bir mashina uchun sanoq yuritadi: nechta o'rin tushirildi, qancha vaqt ketdi, kim ishtirok etdi. Natija ombor tizimidagi hujjat bilan solishtiriladi va farq chiqsa hodisa yaratiladi. Bu kamomad bo'yicha bahsni qisqartiradi, chunki har hodisaga kadr-dalil biriktiriladi.",
        },
        { type: "h3", text: "2. Do'kon javoni va navbat uzunligi" },
        {
            type: "p",
            text:
                "Ikkita o'lchov: javondagi bo'sh joy va kassadagi navbat. Bo'sh javon — bu to'g'ridan-to'g'ri yo'qotilgan sotuv, uni faqat sotuv hisobotidan keyin bilib bo'ladi. Kamera esa buni o'sha kuni, ba'zan o'sha soatning o'zida aytadi. Navbat uzunligi ma'lumoti esa smena jadvalini to'g'rilashga yordam beradi.",
        },
        { type: "h3", text: "3. Ishlab chiqarishda xavfsizlik va texnologik tartib" },
        {
            type: "p",
            text:
                "Kaska, ko'zoynak, jilet, xavfli zonaga ruxsatsiz kirish, uskuna yonidagi noto'g'ri holat. Bu yerda qiymat jarima bilan emas, baxtsiz hodisa ehtimolini kamaytirish bilan o'lchanadi. Amaliyotda shu stsenariy eng tez tasdiqlanadi, chunki ogohlantirish real vaqtda ishlaydi.",
        },
        { type: "image", image: 1 },
        {
            type: "table",
            head: ["Stsenariy", "Kamera soni", "Muddat", "Nima o'lchanadi"],
            rows: [
                [
                    "Ombor: yuklash va tushirish",
                    "2–6 ta darvoza zonasida",
                    "6–10 hafta",
                    "Sanoq farqi, da'volar soni, bitta yuk vaqti",
                ],
                [
                    "Do'kon: javon va navbat",
                    "4–12 ta zal bo'ylab",
                    "8–12 hafta",
                    "Bo'sh javon soatlari, navbat uzunligi, chiqib ketish",
                ],
                [
                    "Ishlab chiqarish: xavfsizlik",
                    "3–8 ta uchastka bo'ylab",
                    "6–10 hafta",
                    "Qoida buzilishi soni, takroriy buzuvchilar, hodisalar",
                ],
                [
                    "Transport: raqam tanish",
                    "1–2 ta kirish-chiqishda",
                    "4–6 hafta",
                    "Kirish vaqti, turib qolish, ruxsatsiz transport",
                ],
            ],
        },

        { type: "h2", text: "Aniqlik necha foiz bo'ladi?" },
        {
            type: "p",
            text:
                "100 foiz aniqlik bo'lmaydi va buni va'da qiladigan taklifga ishonmang. Yaxshi yoritilgan, to'g'ri burchakdagi kamerada raqam tanish va obyekt sanash odatda 90–97 foiz oralig'ida ishlaydi. Murakkab sharoitda — qorong'ilik, yomg'ir, obyektlar bir-birini to'sganda — bu 75–90 foizgacha tushadi.",
        },
        {
            type: "p",
            text:
                "Shuning uchun tizim topshirilganda aniqlik hisoboti beriladi: precision, recall va xato turlari bo'yicha misollar bilan. Bu hujjat keyin bahs uchun asos bo'ladi. Yuzni tanish alohida holat: yaxshi sharoitda 95 foizdan yuqori ishlaydi, lekin niqob, ko'zoynak va yon burchak natijani pasaytiradi — shuning uchun uni kirish nazoratida yagona usul sifatida emas, karta yoki PIN bilan birga ishlatish kerak.",
        },
        {
            type: "callout",
            text:
                "Aniqlik ko'rsatkichi xatoning narxiga bog'lab o'qiladi. Ogohlantirish xarakteridagi stsenariyda 90 foiz yetarli — qolgan 10 foizni operator ko'radi. Avtomatik jarima yoki avtomatik to'lov qarorida esa bu ko'rsatkich yetmaydi, u yerda odam tasdig'i shart.",
        },

        { type: "h2", text: "Tizim qanday quriladi — kameradan ERP'gacha" },
        {
            type: "p",
            text:
                "Arxitektura odatda beshta bo'g'indan iborat va uni loyiha boshida chizib olish kerak, chunki har bo'g'inda alohida xarajat bor.",
        },
        {
            type: "ol",
            items: [
                "IP kameralar — mavjudlari ko'pincha yaraydi, lekin burchak va yoritish tekshiriladi.",
                "Edge qurilma yoki lokal server — tasvir shu yerda qayta ishlanadi, internet uzilsa ham ish to'xtamaydi.",
                "Model — sizning kadrlaringizda o'qitiladi, tayyor universal model kamdan-kam yetarli bo'ladi.",
                "Hodisalar oqimi — jurnal, kadr-dalil va ogohlantirish, odatda Telegram yoki ichki panel orqali.",
                "Integratsiya — hodisalar ERP, ombor tizimi yoki CRM'ga yoziladi, aks holda ular hech kimga ta'sir qilmaydi.",
            ],
        },
        {
            type: "p",
            text:
                "Beshinchi bo'g'in eng ko'p e'tibordan chetda qoladi. Hodisa Telegram'ga tushib, hech kim javobgar bo'lmasa, tizim uch oydan keyin e'tiborsiz qoladi. Shuning uchun har hodisa turiga javobgar shaxs va reaksiya muddati belgilanishi kerak.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Computer vision qancha turadi?" },
        {
            type: "p",
            text:
                "Narx kameralar soniga va stsenariylar murakkabligiga bog'liq. Quyidagi jadvalda Innobek tariflari keltirilgan — bular bir martalik ishlab chiqish narxi.",
        },
        {
            type: "table",
            head: ["Tarif", "Narxi", "Muddat", "Hajmi"],
            rows: [
                [
                    "Pilot",
                    "45 mln so'mdan",
                    "6–8 hafta",
                    "Bitta masala, 1–3 kamera, aniqlik hisoboti, Telegram ogohlantirish",
                ],
                [
                    "Standart",
                    "120 mln so'mdan",
                    "10–14 hafta",
                    "4–16 kamera, bir nechta stsenariy, analitika paneli, ERP integratsiyasi",
                ],
                [
                    "Kelishuv asosida",
                    "Individual",
                    "3 oydan",
                    "Filiallar tarmog'i yoki nostandart model",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kamera, server yoki edge qurilma qiymati kirmaydi — ularni o'zingiz sotib olasiz yoki biz spetsifikatsiya beramiz. Bulut serveri va internet aloqasi to'lovi ham alohida. Bu qism odatda loyiha byudjetining sezilarli ulushini tashkil qiladi, shuning uchun uni birinchi kundan hisobga oling.",
        },
        {
            type: "p",
            text:
                "Yana bir xarajat — sizning tomondan ketadigan vaqt. Kadrlarni belgilash bosqichida obyektdan video yig'iladi va 2 000 – 5 000 kadr qo'lda belgilanadi. Bu bosqich eng uzun davom etadi va aniqlikni aynan u belgilaydi.",
        },

        { type: "h2", text: "Qaytim qanday hisoblanadi" },
        {
            type: "p",
            text:
                "Hisobni ombor misolida ochiq ko'rsatamiz. O'z raqamlaringizni qo'ying — formula o'zgarmaydi.",
        },
        {
            type: "ol",
            items: [
                "Yillik kamomad va da'vo summasi qancha? Masalan, 180 mln so'm.",
                "Uning qancha qismi yuklash va tushirish bosqichida yuzaga keladi? Aytaylik, yarmi — 90 mln so'm.",
                "Video nazorat bilan buning qancha qismi oldi olinadi? Realistik mo'ljal — 30–50 foiz.",
                "Yillik tejamkorlik: 90 mln × 0,4 = 36 mln so'm.",
            ],
        },
        {
            type: "p",
            text:
                "Shu misolda 45 mln so'mlik pilot taxminan 15 oyda o'zini oqlaydi. Agar davlat dasturi orqali xarajatning yarmi qoplansa, muddat 7–8 oyga tushadi. Ishlab chiqarish stsenariysida esa hisob boshqacha quriladi: u yerda asosiy qiymat — bitta oldi olingan baxtsiz hodisa, uning narxi to'xtab qolgan smena va tekshiruv bilan o'lchanadi.",
        },

        { type: "h2", text: "Nazorat qilmaslikning narxi" },
        {
            type: "list",
            items: [
                "Kamomad sababi topilmaydi va u tannarxga singib ketadi — hech kim uni alohida ko'rmaydi.",
                "Yetkazib beruvchi bilan bahsda dalil yo'q: yozuv bor, lekin uni qidirishga vaqt yo'q.",
                "Bo'sh javon soatlab turadi, sotuv esa hisobotda shunchaki past ko'rinadi.",
                "Xavfsizlik qoidasi buzilishi hodisa yuz bermaguncha qayd etilmaydi.",
                "Hujjat va jismoniy qoldiq o'rtasidagi farq tekshiruv paytida ochiladi — endi bu yuqori soliq riski omili hisoblanadi.",
            ],
        },

        { type: "h2", text: "Xavflar va qonuniy cheklovlar" },
        {
            type: "p",
            text:
                "Video bilan ishlash shaxsiy ma'lumotlar sohasiga tegadi, shuning uchun loyihani huquqiy tomondan tayyorlash kerak. Kuzatuv haqida ogohlantirish belgilari, xodimlar bilan hujjatlashtirilgan tanishtirish va yozuvni saqlash muddati — bular texnik masala emas, tashkiliy masala.",
        },
        {
            type: "list",
            items: [
                "Yuzni tanish va biometrik ma'lumotga tegadigan stsenariylar alohida ehtiyotkorlik talab qiladi — ularni yuristingiz bilan kelishing.",
                "Yozuvni saqlash muddati va kimga ko'rinishi oldindan belgilanadi; audit jurnali bo'lishi kerak.",
                "Xodimni jazolash uchun yagona dalil sifatida modelning xulosasidan foydalanmang — aniqlik 100 foiz emas.",
                "Sharoit o'zgarsa model sifati pasayadi: yangi qadoq, kamera siljishi, fasliy yoritish. Qayta o'qitish odatda yiliga bir yoki ikki marta bo'ladi.",
                "Yomon yoritilgan yoki noto'g'ri burchakdagi kamera hech qanday model bilan tuzalmaydi — avval kamerani to'g'rilash kerak.",
            ],
        },

        { type: "h2", text: "Qachon computer vision mos emas" },
        {
            type: "list",
            items: [
                "Hodisa kam sodir bo'ladi. Oyiga bir-ikki marta yuzaga keladigan holat uchun tizim qimmat turadi.",
                "Jarayonning o'zi tartibsiz: qoldiq hisobi yuritilmasa, kamera faqat tartibsizlikni tasdiqlaydi.",
                "Hodisaga javob beradigan odam yo'q. Ogohlantirish borib, hech kim harakat qilmasa, foyda nolga teng.",
                "Kameralar yaroqsiz joyda va ularni ko'chirish imkoni yo'q.",
                "Byudjet faqat dasturga yetadi, uskuna va qo'llab-quvvatlashga qolmaydi.",
            ],
        },

        { type: "h2", text: "Pilotni qanday boshlash kerak" },
        {
            type: "ol",
            items: [
                "Bitta masalani tanlang va uni bir gapda yozing: nimani o'lchaymiz va qanday aniqlik yetarli.",
                "Hozirgi ko'rsatkichni qayd eting: kamomad summasi, buzilishlar soni yoki bo'sh javon soatlari.",
                "1–3 kamerani tanlang va ulardan bir necha kunlik video yig'ing.",
                "6–8 haftalik pilotni ishga tushiring, aniqlik hisobotini oling.",
                "Hodisalarga javobgar shaxs va reaksiya muddatini belgilang.",
                "Natija mezonga yetsa, obyekt bo'ylab kengaytiring va davlat qoplash dasturi shartlarini tekshiring.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "quote",
            text:
                "Kamera muammoni hal qilmaydi — u muammoni ko'rinadigan qiladi. Qaror baribir odam tomonidan qabul qilinadi.",
        },
    ],

    faq: [
        {
            q: "Computer vision joriy etish qancha turadi?",
            a: "Innobek'da pilot loyiha 45 000 000 so'mdan boshlanadi: bu bitta masala va 1–3 kamera uchun to'liq ishlaydigan yechim. Obyekt bo'ylab to'liq joriy etish, ya'ni 4–16 kamera va bir nechta stsenariy, 120 000 000 so'mdan. Filiallar tarmog'i uchun narx kelishuv asosida. Kamera va server qiymati narxga kirmaydi.",
        },
        {
            q: "Aniqlik necha foiz bo'ladi?",
            a: "100 foiz aniqlik bo'lmaydi va buni va'da qiladigan taklifga ishonmang. Yaxshi yoritilgan, to'g'ri burchakdagi kamerada raqam tanish va obyekt sanash odatda 90–97 foiz oralig'ida ishlaydi. Murakkab sharoitda — qorong'ilik, yomg'ir, obyektlar bir-birini to'sganda — bu 75–90 foizgacha tushadi. Aniq raqam pilotdan keyin test to'plamida o'lchanadi.",
        },
        {
            q: "Mavjud kameralarim yaraydimi?",
            a: "Ko'p holatda ha, agar tasvir sifati va burchak mos bo'lsa. Tekshiriladigan uchta narsa bor: obyekt kadrda yetarlicha katta ko'rinadimi, yoritish kun bo'yi barqarormi va kamera oqimiga tarmoq orqali kirish mumkinmi. Ba'zi nuqtalarda kamerani ko'chirish yoki qo'shimcha yoritish qo'yish kerak bo'ladi — buni loyiha boshida aytamiz.",
        },
        {
            q: "Internet uzilsa tizim to'xtaydimi?",
            a: "Yo'q, agar tasvir edge qurilmada yoki lokal serverda qayta ishlansa. Bu holatda model obyektning o'zida ishlaydi, hodisalar lokal bazaga yoziladi va aloqa tiklanganda markazga uzatiladi. Bulutli variantda esa uzilish ishni to'xtatadi. Ombor va ishlab chiqarish uchun odatda lokal variant tanlanadi.",
        },
        {
            q: "Video shaxsiy ma'lumot hisoblanadimi?",
            a: "Odamning tasviri shaxsiy ma'lumotga tegishi mumkin, shuning uchun loyihani huquqiy tomondan tayyorlash kerak. Kuzatuv haqida ogohlantirish belgilari, xodimlarni hujjatlashtirilgan tanishtirish, yozuvni saqlash muddati va kimga ko'rinishi oldindan belgilanadi. Yuzni tanish va biometrik ma'lumot bilan bog'liq stsenariylar alohida ehtiyotkorlik talab qiladi — ularni yuristingiz bilan kelishing.",
        },
        {
            q: "Qachon computer vision kerak emas?",
            a: "Hodisa oyiga bir-ikki marta sodir bo'lsa, tizim xarajatini oqlamaydi. Ombor yoki qoldiq hisobi umuman yuritilmasa, avval hisobni yo'lga qo'ying — kamera tartibsizlikni tuzatmaydi. Hodisaga javob beradigan odam belgilanmagan bo'lsa ham boshlamang. Byudjet faqat dasturga yetib, kamera, server va qo'llab-quvvatlashga qolmasa, loyihani kechiktiring.",
        },
    ],

    cta: {
        h: "Masalangiz kamera bilan yechiladimi — bepul tekshiramiz",
        p:
            "Obyektingizni va hozirgi kameralaringizni ko'rib chiqamiz, qaysi stsenariy real natija berishini va qanday aniqlikka erishish mumkinligini aytamiz. Keyin aniq narx va muddat beramiz.",
        button: "Konsultatsiya olish",
    },

    images: [
        {
            src: "/assets/img/blog/computer-vision-ombor-cover.webp",
            alt: "Ombor kamerasidagi tasvir va palletlarni aniqlagan computer vision ramkalari",
            caption: "Tizim hodisani real vaqtda belgilaydi va kadr-dalil bilan xabar yuboradi",
            prompt:
                "Warehouse camera view with computer-vision overlay: bounding boxes around pallets and a forklift, a counter badge in the corner, subtle grid and confidence markers; realistic industrial footage look with clean UI overlay, teal detection boxes, no readable text or logos, 16:9",
        },
        {
            src: "/assets/img/blog/computer-vision-stsenariylar.webp",
            alt: "Computer vision uchun uchta amaliy stsenariy kartochka ko'rinishida ko'rsatilgan",
            caption: "Ombor, do'kon va ishlab chiqarish — uchta eng tez tasdiqlanadigan stsenariy",
            prompt:
                "Three scenario cards: warehouse loading verification, retail shelf and queue monitoring, production safety compliance; each card with a camera icon, a metric badge and a payback meter; clean flat cards, teal and blue, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/computer-vision-arxitektura.webp",
            alt: "Computer vision tizimi arxitekturasi: kamera, edge qurilma, model, hodisalar va ERP",
            caption: "Beshinchi bo'g'in — integratsiya — eng ko'p e'tibordan chetda qoladi",
            prompt:
                "System architecture sketch: IP cameras to edge device or local server to vision model to events feed to ERP and notification channel; clean technical line diagram with small icons, blue highlights, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/projects/firewise.webp",
            alt: "FireWise loyihasi — xavfsizlik nazorati tizimi interfeysi ekranda ko'rsatilgan",
            caption: "FireWise — Innobek portfelidagi xavfsizlik nazorati loyihasi",
        },
    ],

    relatedServices: ["computer-vision", "sun-iy-intellekt", "erp-tizimlar"],
    relatedPosts: ["ai-ni-kichik-biznesga-joriy-etish", "ai-chatbot-yoki-jonli-operator"],
};

const ru = {
    meta: {
        title: "Компьютерное зрение для бизнеса: цена, точность, срок",
        description:
            "Компьютерное зрение для бизнеса: три сценария на складе, в магазине и на производстве, точность 90–97%, цена от 45 млн сум и расчёт окупаемости.",
        keywords: [
            "компьютерное зрение для бизнеса Узбекистан",
            "видеоаналитика на складе",
            "контроль СИЗ на производстве камерой",
            "распознавание номеров и товаров",
            "стоимость системы компьютерного зрения",
            "computer vision внедрение",
            "видеоаналитика в магазине",
        ],
    },
    h1: "Computer vision на практике: что камера контролирует на складе, в магазине и на производстве",
    lead:
        "Камеры давно стоят, но запись никто не смотрит — к ней возвращаются только после происшествия. Computer vision анализирует тот же поток в реальном времени и сам сообщает о событии. Разбираем три практических сценария, честные цифры точности, цену и расчёт окупаемости.",
    category: "Искусственный интеллект",
    readingTime: "11 минут",

    body: [
        {
            type: "p",
            text:
                "На большинстве объектов видеонаблюдение работает как архив. Когда недостачу уже обнаружили, оператор часами отсматривает запись и чаще всего ничего не находит. Computer vision переворачивает эту логику: система отмечает событие сразу и присылает уведомление с кадром-доказательством.",
        },
        {
            type: "p",
            text:
                "Почему тема стала актуальной именно сейчас? Причин две. Первая — государственная: на 2025–2026 годы утверждён перечень из более чем 60 проектов по внедрению ИИ, а в программе ИИ-партнёр для 10 000 предприятий объявлена компенсация 50 процентов расходов на внедрение. Вторая — ужесточение контроля: с 1 сентября 2026 года нарушение правил маркировки считается фактором высокого налогового риска, то есть сверять физический поток товара с документами теперь обязательно.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Что computer vision делает и чего не умеет" },
        {
            type: "p",
            text:
                "Computer vision — это модель, которая автоматически анализирует изображение с камеры. Она находит объект в кадре, считает его, отслеживает движение и создаёт событие, если происходящее не совпадает с заранее согласованным правилом. Например, считает выгруженные паллеты при приезде машины или отмечает сотрудника без каски.",
        },
        {
            type: "p",
            text:
                "Стоит сказать и о том, чего она не умеет. Модель не понимает намерений и не знает контекста — она видит только те объекты, которым её научили. Появился новый тип упаковки или сдвинулся ракурс камеры — качество падает. Поэтому цикл дообучения планируется в проекте заранее.",
        },

        { type: "h2", text: "Три практических сценария" },
        { type: "h3", text: "1. Проверка погрузки и разгрузки на складе" },
        {
            type: "p",
            text:
                "Камера следит за зоной ворот и ведёт счёт по каждой машине: сколько мест выгружено, сколько времени ушло, кто участвовал. Результат сверяется с документом в складской системе, и при расхождении создаётся событие. Это сокращает споры по недостаче, потому что к каждому событию прикреплён кадр-доказательство.",
        },
        { type: "h3", text: "2. Полка магазина и длина очереди" },
        {
            type: "p",
            text:
                "Здесь два показателя: пустое место на полке и очередь на кассе. Пустая полка — это прямая потеря продаж, и обычно о ней узнают только из отчёта. Камера сообщает об этом в тот же день, иногда в тот же час. А данные по очередям помогают правильно составить график смен.",
        },
        { type: "h3", text: "3. Безопасность и техрегламент на производстве" },
        {
            type: "p",
            text:
                "Каска, очки, жилет, вход в опасную зону без допуска, неверное положение у станка. Ценность здесь измеряется не штрафами, а снижением вероятности несчастного случая. На практике этот сценарий подтверждается быстрее других, потому что предупреждение срабатывает в реальном времени.",
        },
        { type: "image", image: 1 },
        {
            type: "table",
            head: ["Сценарий", "Число камер", "Срок", "Что измеряется"],
            rows: [
                [
                    "Склад: погрузка и разгрузка",
                    "2–6 в зоне ворот",
                    "6–10 недель",
                    "Расхождение счёта, число претензий, время на машину",
                ],
                [
                    "Магазин: полка и очередь",
                    "4–12 по залу",
                    "8–12 недель",
                    "Часы пустой полки, длина очереди, уходы без покупки",
                ],
                [
                    "Производство: безопасность",
                    "3–8 по участкам",
                    "6–10 недель",
                    "Число нарушений, повторные нарушители, происшествия",
                ],
                [
                    "Транспорт: распознавание номеров",
                    "1–2 на въезде",
                    "4–6 недель",
                    "Время въезда, простой, транспорт без допуска",
                ],
            ],
        },

        { type: "h2", text: "Какой будет точность в процентах?" },
        {
            type: "p",
            text:
                "Точности 100 процентов не бывает, и предложению с такой гарантией доверять не стоит. При хорошем освещении и правильном ракурсе распознавание номеров и подсчёт объектов обычно дают точность 90–97 процентов. В сложных условиях — темнота, дождь, перекрытие объектов — показатель падает до 75–90.",
        },
        {
            type: "p",
            text:
                "Поэтому при сдаче системы выдаётся отчёт о точности: precision, recall и примеры по типам ошибок. Этот документ потом служит основанием в спорах. Распознавание лиц — отдельный случай: при хороших условиях оно работает выше 95 процентов, но маска, очки и боковой ракурс снижают результат, поэтому в контроле доступа его используют вместе с картой или PIN-кодом.",
        },
        {
            type: "callout",
            text:
                "Цифру точности нужно читать вместе с ценой ошибки. Для предупреждающего сценария 90 процентов достаточно — оставшиеся 10 просмотрит оператор. Для автоматического штрафа или автоматического платежа этого мало: там обязательно подтверждение человеком.",
        },

        { type: "h2", text: "Как строится система — от камеры до ERP" },
        {
            type: "p",
            text:
                "Архитектура обычно состоит из пяти звеньев, и нарисовать её нужно в начале проекта: в каждом звене есть собственная статья расходов.",
        },
        {
            type: "ol",
            items: [
                "IP-камеры — существующие чаще всего подходят, но ракурс и освещение проверяются отдельно.",
                "Edge-устройство или локальный сервер — здесь обрабатывается поток, и работа не останавливается при обрыве интернета.",
                "Модель — обучается на ваших кадрах; готовой универсальной модели почти никогда не хватает.",
                "Поток событий — журнал, кадр-доказательство и уведомление, обычно в Telegram или во внутренней панели.",
                "Интеграция — события пишутся в ERP, складскую систему или CRM, иначе они ни на что не влияют.",
            ],
        },
        {
            type: "p",
            text:
                "Пятое звено забывают чаще всего. Если событие падает в Telegram и ни за кем не закреплено, через три месяца на него перестают смотреть. Поэтому по каждому типу события назначаются ответственный и срок реакции.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько стоит computer vision?" },
        {
            type: "p",
            text:
                "Цена зависит от числа камер и сложности сценариев. В таблице ниже — тарифы Innobek, это разовая стоимость разработки.",
        },
        {
            type: "table",
            head: ["Тариф", "Цена", "Срок", "Объём"],
            rows: [
                [
                    "Пилот",
                    "от 45 млн сум",
                    "6–8 недель",
                    "Одна задача, 1–3 камеры, отчёт о точности, уведомления в Telegram",
                ],
                [
                    "Стандарт",
                    "от 120 млн сум",
                    "10–14 недель",
                    "4–16 камер, несколько сценариев, панель аналитики, интеграция с ERP",
                ],
                [
                    "По договору",
                    "Индивидуально",
                    "от 3 месяцев",
                    "Сеть филиалов или нестандартная модель",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Стоимость камер, сервера и edge-устройства в смету не входит — вы покупаете их сами либо по нашей спецификации. Облачный сервер и канал связи тоже оплачиваются отдельно. Эта часть обычно занимает заметную долю бюджета, поэтому учитывайте её с первого дня.",
        },
        {
            type: "p",
            text:
                "Ещё один расход — время с вашей стороны. На этапе разметки собирается видео с объекта и вручную размечаются 2 000 – 5 000 кадров. Этап самый долгий, и именно он определяет итоговую точность.",
        },

        { type: "h2", text: "Как считается окупаемость" },
        {
            type: "p",
            text:
                "Покажем расчёт на складском примере. Подставьте свои цифры — формула не изменится.",
        },
        {
            type: "ol",
            items: [
                "Какова годовая сумма недостач и претензий? Допустим, 180 млн сум.",
                "Какая часть возникает на погрузке и разгрузке? Пусть половина — 90 млн сум.",
                "Какую долю из этого снимет видеоконтроль? Реалистичный ориентир — 30–50 процентов.",
                "Годовая экономия: 90 млн × 0,4 = 36 млн сум.",
            ],
        },
        {
            type: "p",
            text:
                "В этом примере пилот за 45 млн сум окупается примерно за 15 месяцев. Если половину расходов покроет государственная программа, срок сокращается до 7–8 месяцев. На производстве расчёт строится иначе: там основная ценность — предотвращённый несчастный случай, а его цена измеряется остановленной сменой и проверкой.",
        },

        { type: "h2", text: "Сколько стоит не контролировать" },
        {
            type: "list",
            items: [
                "Причину недостачи не находят, и она растворяется в себестоимости — отдельной строкой её никто не видит.",
                "В споре с поставщиком нет доказательства: запись есть, но искать в ней некому.",
                "Пустая полка стоит часами, а продажи в отчёте просто выглядят низкими.",
                "Нарушение техники безопасности фиксируется только после происшествия.",
                "Расхождение между документами и фактическим остатком вскрывается при проверке — а это теперь фактор высокого налогового риска.",
            ],
        },

        { type: "h2", text: "Риски и правовые ограничения" },
        {
            type: "p",
            text:
                "Работа с видео затрагивает сферу персональных данных, поэтому проект нужно готовить и с юридической стороны. Предупреждающие таблички, документально оформленное ознакомление сотрудников и срок хранения записи — это не технические, а организационные вопросы.",
        },
        {
            type: "list",
            items: [
                "Сценарии с распознаванием лиц и биометрией требуют отдельной осторожности — согласуйте их со своим юристом.",
                "Срок хранения записи и круг лиц с доступом определяются заранее; журнал аудита обязателен.",
                "Не используйте вывод модели как единственное доказательство для взыскания с сотрудника — точность не равна 100 процентам.",
                "При изменении условий качество падает: новая упаковка, сдвиг камеры, сезонное освещение. Дообучение обычно нужно один-два раза в год.",
                "Никакая модель не исправит плохое освещение или неудачный ракурс — сначала правится камера.",
            ],
        },

        { type: "h2", text: "Когда computer vision не подходит" },
        {
            type: "list",
            items: [
                "События происходят редко. Для случая, который бывает раз-два в месяц, система обойдётся дороже проблемы.",
                "Сам процесс не упорядочен: если складской учёт не ведётся, камера лишь подтвердит беспорядок.",
                "Нет человека, который реагирует на событие. Уведомление приходит, никто не действует — польза равна нулю.",
                "Камеры стоят в неподходящих местах, а перенести их невозможно.",
                "Бюджета хватает только на софт, а на оборудование и поддержку не остаётся.",
            ],
        },

        { type: "h2", text: "Как начать пилот" },
        {
            type: "ol",
            items: [
                "Выберите одну задачу и сформулируйте её одним предложением: что измеряем и какая точность достаточна.",
                "Зафиксируйте текущий показатель: сумма недостач, число нарушений или часы пустой полки.",
                "Выберите 1–3 камеры и соберите с них видео за несколько дней.",
                "Запустите пилот на 6–8 недель и получите отчёт о точности.",
                "Назначьте ответственного за события и срок реакции.",
                "Если результат укладывается в критерий — масштабируйте на объект и проверьте условия государственной компенсации.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "quote",
            text:
                "Камера не решает проблему — она делает её видимой. Решение всё равно принимает человек.",
        },
    ],

    faq: [
        {
            q: "Сколько стоит внедрение computer vision?",
            a: "В Innobek пилотный проект начинается от 45 000 000 сум: это полноценное решение для одной задачи и 1–3 камер. Полное внедрение на объекте, то есть 4–16 камер и несколько сценариев, — от 120 000 000 сум. Для сети филиалов цена определяется индивидуально. Стоимость камер и сервера в смету не входит.",
        },
        {
            q: "Какой будет точность в процентах?",
            a: "Точности 100 процентов не бывает, и предложению с такой гарантией доверять не стоит. При хорошем освещении и правильном ракурсе распознавание номеров и подсчёт объектов обычно дают точность 90–97 процентов. В сложных условиях — темнота, дождь, перекрытие объектов — показатель падает до 75–90. Точную цифру измеряем на тестовой выборке после пилота.",
        },
        {
            q: "Подойдут ли мои существующие камеры?",
            a: "В большинстве случаев да, если качество изображения и ракурс подходят. Проверить нужно три вещи: достаточно ли крупно объект виден в кадре, стабильно ли освещение в течение дня и есть ли сетевой доступ к потоку камеры. В отдельных точках камеру придётся перенести или добавить освещение — об этом мы говорим в начале проекта.",
        },
        {
            q: "Остановится ли система при обрыве интернета?",
            a: "Нет, если поток обрабатывается на edge-устройстве или локальном сервере. Тогда модель работает прямо на объекте, события пишутся в локальную базу и передаются в центр после восстановления связи. В облачном варианте обрыв останавливает работу. Именно поэтому для склада и производства обычно выбирают локальный вариант.",
        },
        {
            q: "Видео считается персональными данными?",
            a: "Изображение человека может относиться к персональным данным, поэтому проект нужно готовить и юридически. Предупреждающие таблички, документально оформленное ознакомление сотрудников, срок хранения записи и круг лиц с доступом определяются заранее. Сценарии с распознаванием лиц и биометрией требуют отдельной осторожности — согласуйте их со своим юристом.",
        },
        {
            q: "Когда computer vision не нужен?",
            a: "Если событие происходит раз-два в месяц, система не окупит себя. Если складской учёт вообще не ведётся, сначала наладьте учёт — камера беспорядок не исправит. Не начинайте и там, где не назначен человек, реагирующий на события. А если бюджета хватает только на софт и не остаётся на камеры, сервер и поддержку, проект лучше отложить.",
        },
    ],

    cta: {
        h: "Бесплатно проверим, решается ли задача камерой",
        p:
            "Посмотрим ваш объект и существующие камеры, скажем, какой сценарий даст реальный результат и какая точность достижима. Затем назовём точную цену и срок.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/blog/computer-vision-ombor-cover.webp",
            alt: "Изображение со склада с рамками распознавания паллет системой computer vision",
            caption: "Система отмечает событие в реальном времени и присылает кадр-доказательство",
            prompt:
                "Warehouse camera view with computer-vision overlay: bounding boxes around pallets and a forklift, a counter badge in the corner, subtle grid and confidence markers; realistic industrial footage look with clean UI overlay, teal detection boxes, no readable text or logos, 16:9",
        },
        {
            src: "/assets/img/blog/computer-vision-stsenariylar.webp",
            alt: "Три карточки практических сценариев computer vision для бизнеса",
            caption: "Склад, магазин и производство — три сценария, которые подтверждаются быстрее всего",
            prompt:
                "Three scenario cards: warehouse loading verification, retail shelf and queue monitoring, production safety compliance; each card with a camera icon, a metric badge and a payback meter; clean flat cards, teal and blue, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/computer-vision-arxitektura.webp",
            alt: "Архитектура системы computer vision: камеры, edge-устройство, модель, события и ERP",
            caption: "Пятое звено — интеграцию — забывают чаще всего",
            prompt:
                "System architecture sketch: IP cameras to edge device or local server to vision model to events feed to ERP and notification channel; clean technical line diagram with small icons, blue highlights, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/projects/firewise.webp",
            alt: "Проект FireWise — интерфейс системы контроля безопасности на экране",
            caption: "FireWise — проект Innobek в области контроля безопасности",
        },
    ],

    relatedServices: ["computer-vision", "sun-iy-intellekt", "erp-tizimlar"],
    relatedPosts: ["ai-ni-kichik-biznesga-joriy-etish", "ai-chatbot-yoki-jonli-operator"],
};

const content = { uz, ru };

export default content;
